import { MatSnackBar } from '@angular/material/snack-bar';


import { BehaviorSubject, Observable } from 'rxjs';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HierarchyDto, PipelineLicenseStageDto, PipelineLicenseStakeholderDto, PLActivityActionPersonDto, PLStageActivityDto, PLStakeholderMatrixDto, PLStakeholderMatrixRaciDto, PipelineLicenseCategoryDto, IdentityUserDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { Guid } from 'guid-typescript';
import { Any } from 'typeorm';
@Component({
  selector: 'cradua-add-pl-stage-activity',
  templateUrl: './add-pl-stage-activity.component.html',
  styleUrls: ['./add-pl-stage-activity.component.css']
})
export class AddPlStageActivityComponent implements OnInit {
  activityForm: FormGroup;
  @Input() editActivity: Observable<PLStageActivityDto>
  @Input() plstakeholdersmatrix: PLStakeholderMatrixDto[];
  @Input() plstakeholdersmatrixraci: PLStakeholderMatrixRaciDto[]
  @Input() plstageactivities: PLStageActivityDto[];
  @Output() submiteventemitter = new EventEmitter<any[]>();
  @Output() deleteRaciEvent = new EventEmitter();
  @Output() deleteActivityEvent= new EventEmitter()
  @Output() deleteMatrixEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() racies: HierarchyDto[];
  @Input() stakeholders: PipelineLicenseStakeholderDto[];
  @Input() stages: PipelineLicenseStageDto[];
  @Input() actionpersons: PLActivityActionPersonDto[];
  @Input() identityusers: IdentityUserDto[];
  @Input() selectedCategory: Observable<PipelineLicenseCategoryDto>;
  @Input() templateId: any;

  newActivity = false;
 selectedCategoryId: any;
  filteredDeleteActivity = [];
  filterDeleteMatrix = [];
  filteredDeleteRaci = [];
  savedstages = [];
  savedactivities = [];

  filteredDeleteStage = [];
  constructor(
    private fb: FormBuilder,
    private matSnackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.createForm();
    this.addCategoryId();
  }

  ngOnChanges(): void {
  
  }

  addCategoryId() {

    this.selectedCategory.subscribe(a => {
      this.selectedCategoryId = a;
      this.activityForm.patchValue({
        PipelineLicenseCategoryId: a,
        TemplateId: this.templateId});
     });
  }

get f () {
  return this.activityForm.controls;
}


  createForm() {
    // this.activityForm.controls[''].errors.required
    this.activityForm =  this.fb.group({
      PipelineLicenseStageName: ['', Validators.required],
      PipelineLicenseCategoryId: ['', Validators.required],
      EstimatedDuration: ['', Validators.required],
      StageNo: [0],
      TemplateId: [''],
      newStage: true,
      id:  Guid.create().toString()
    });
  }

activityFormGroup(data) {
 if(data.Activity && data.Activity.EstimatedDuration > data.EstimatedDuration) {
  this.activityMessage();
 } else {
  this.activityForm =  this.fb.group({
    PipelineLicenseStageName: [data.PipelineLicenseStageName, Validators.required],
    PipelineLicenseCategoryId: [data.PipelineLicenseCategoryId, Validators.required],
    EstimatedDuration: [data.EstimatedDuration, Validators.required],
    StageNo: data.StageNo,
    TemplateId: [data.TemplateId],
    newStage: data.newStage,
    id:  data.id,
    Activity:  this.fb.group( {
      id: Guid.create().toString(),
      isNew: true,
      CreatedById: [''],
      ModifiedById: [''],
      SiteId: [''],
      SubscriberId: [''],
      TemplateId: [''],
      PLStageId: [''],
      Name: ['', Validators.required],
      EstimatedDuration: ['', Validators.required],
      Stakeholdermatrix : this.fb.array([]),
      Actionpersons : this.fb.array([])
     })
  });
 }
}

findsavedstageByNo() {
return this.stages.filter(stage => stage.PipelineLicenseCategoryId === this.selectedCategoryId && stage.TemplateId === this.templateId).reduce((a,b) => {
  return  Math.max(a, b.StageNo)
},0);
}


findstavedstageByNo() {
  return this.savedstages.filter(stage => stage.PipelineLicenseCategoryId === this.selectedCategoryId && stage.TemplateId === this.templateId).reduce((a,b) => {
    return  Math.max(a, b.StageNo)
  },0);
  }

  findExitingActivityByNo(id) {
    return this.plstageactivities.filter(data => data.PLStageId === id).reduce((a,b) => {
      return  Math.max(a, b.ActivityNo)
    },0);
    }

    findsavedActivityByNo(id) {
      return this.savedactivities.filter(dd => dd.PLStageId === id).reduce((a,b) => {
        return  Math.max(a, b.ActivityNo)
      },0);
     }



generateStageN0() {
  let numb = 0;
  let numb2 = 0;
  numb2 = this.findstavedstageByNo();
  numb = this.findsavedstageByNo();
  return this.generateNo(numb, numb2);
}

generateNo(numb, numb2) {
  if(numb >= numb2) {
    return numb += 1;
  } else {
    return numb2 += 1;
  }
}


generateActivityNo(id) {
  let numb = 0;
  let numb2 = 0;
  numb2 = this.findsavedActivityByNo(id);
  numb = this.findExitingActivityByNo(id);
  return this.generateNo(numb, numb2);
}



formMessage() {
  this.matSnackBar.open('Please fill all the required feild', 'Exit', {duration: 1000});
}


  addActivity(stage) {   
    if(this.activityForm.valid) {
      this.newActivity = true;
      const findsavedstage = this.getSavedStage(stage.id)
      stage.StageNo  =  stage.StageNo > 0 ? stage.StageNo : this.generateStageN0();
      if(findsavedstage) {
      this.savedstages = this.savedstages.filter(st => st.id !== stage.id);
      this.savedstages.push({
        PipelineLicenseStageName: stage.PipelineLicenseStageName,
        PipelineLicenseCategoryId: stage.PipelineLicenseCategoryId,
        StageNo: stage.StageNo,
        TemplateId: stage.TemplateId,
        EstimatedDuration: stage.EstimatedDuration,
        newStage: stage.newStage,
        id: stage.id
      });
      } else {
        this.savedstages.push({
          PipelineLicenseStageName: stage.PipelineLicenseStageName,
          PipelineLicenseCategoryId: stage.PipelineLicenseCategoryId,
          EstimatedDuration: stage.EstimatedDuration,
          TemplateId: stage.TemplateId,
          newStage: stage.newStage,
          StageNo: stage.StageNo,
          id: stage.id
        });

      }

     if(stage.Activity) {
      if(this.activityForm.valid) {

        if(stage.Activity.EstimatedDuration > stage.EstimatedDuration)  {
          this.activityMessage()
        } else {
          stage.Activity.ActivityNo = stage.Activity.ActivityNo > 0  ? stage.Activity.ActivityNo : this.generateActivityNo(stage.id);
          const findactivity = this.savedactivities.find(a => a.id === stage.Activity.id);
          if(findactivity) {
            this.savedactivities = this.savedactivities.filter(saveactivity => saveactivity.id !== findactivity.id);
            this.savedactivities.push(stage.Activity);
          } else {
            stage.Activity.TemplateId = stage.TemplateId;
            stage.Activity.PLStageId = stage.id;
            this.savedactivities.push(stage.Activity);
          }
        }
       
      }
     } 
      
     if(this.activityForm.valid) {
        this.activityFormGroup(stage)
      } 

  } else {
     this.formMessage();
   }

}

activityMessage() {
  this.matSnackBar.open('Activity Duration must not be greater than stage duration!', 'Exit', {duration: 3000});
}
  addMatrix(stakeholder) {
   
    const control = this.activityForm.controls.Activity.get('Stakeholdermatrix') as FormArray;
    const std = control.value.find(holder => holder.PLStakeholderId === stakeholder.id)
  if(this.activityForm.valid) {
    if(!std) {
      control.insert(0, this.fb.group({
        id: Guid.create().toString(),
        isNew: true,
        CreatedById: [''],
        ModifiedById: [''],
        SiteId: [''],
        SubscriberId: [''],
        TemplateId: [this.activityForm.controls.Activity.value.TemplateId],
        EstimatedDuration: ['', [Validators.required]],
        PLStakeholderId: [stakeholder.id, Validators.required],
        PLStageActivityId: [this.activityForm.controls.Activity.value.id],
        Racies: this.fb.array([])
      }))
    
    } else if(this.activityForm) {
      this.matSnackBar.open('Stake holder already exists', 'Close', {duration: 3000})
    }
  } else {
    this.matSnackBar.open('Please fill all the tast field first!', 'Exit', {duration: 3000});
  }
    
}

  addActivityAction(StaffId) {

    if(this.activityForm.invalid) {
      this.matSnackBar.open('Please fill all the task field first!!', 'Exit', {duration: 3000});
    } else {
      const control = this.activityForm.controls.Activity.get('Actionpersons') as FormArray;
      control.insert(0, this.fb.group({
        id: Guid.create().toString(),
        isNew: true,
        CreatedById: [''],
        ActivityNo: [],
        ModifiedById: [''],
        SiteId: [''],
        SubscriberId: [''],
        StaffId: StaffId,
        PLStageActivityId: [this.activityForm.controls.Activity.value.id],
      }));
  
    }
  }

addRaci(raciId, stake, i: number) {

  if(this.activityForm.invalid) {
    this.matSnackBar.open('Please fill all the matrix field first!', 'Exit', {duration: 3000});
    
  } else {
    const control = (this.activityForm.controls.Activity.get('Stakeholdermatrix')  as FormArray).at(i).get('Racies') as FormArray;
  control.insert(0, this.fb.group({
    id: Guid.create().toString(),
    isNew: true,
      CreatedById: [''],
      ModifiedById: [''],
      SiteId: [''],
      SubscriberId: [''],
      TemplateId: [stake.TemplateId],
      PLStakeholderMatrixId: [stake.id, Validators.required],
      RaciId: [raciId, Validators.required]
  }));

  }
}

getStage(id) {
return this.stages.find(stage => stage.id === id)
}

backToTemplate(){
  this.backEvent.emit({isview: false})
}
getSavedStage(id) {
  return this.savedstages.find(stage => stage.id === id)
  }
getStakeholderName(id) {
    const holder = this.stakeholders.find( data => data.id === id)
    return holder ? holder.PipelineLicenseStakeholderName: '';
  }

  getRaciName(item) {
    const raci =  this.racies.find( a => a.id === item.RaciId);
    return raci ? raci.Abbreviation : '';
  }

  getIdentityUser(id) {
    const user =  this.identityusers.find( a => a.Id === id);
    return user ? user.StaffName: '';
  }

  // this method check for stake holder already added to the activity form
   checkActivity(stage) {
    if(stage.Activity.EstimatedDuration > stage.EstimatedDuration) {
      this.activityForm.patchValue({Activity: {
        EstimatedDuration: stage.EstimatedDuration
      }});
      this.activityMessage();
    }
  }

  checkMatrixDuration(matNo: number,  activity, i:  number,) {
    const actNo = activity.EstimatedDuration
       let control = (this.activityForm.controls.Activity.get('Stakeholdermatrix') as FormArray).at(i);
       if(matNo > actNo) {
         control.patchValue({EstimatedDuration: actNo})
       }
    }

  checkMatrix(id, i, j) {
    let check;
      if(id && (i >= 0 && j >= 0)) {
        const control = ((this.activityForm.get('Activities') as FormArray).at(i).get('Stakeholdermatrix') as FormArray).at(j).get('Racies') as FormArray;
       check =  control.controls.find(b => b.value.PLStakeholderMatrixId === id)
      }
     return check ? true : false;
    }



  deleteActivity(value, i) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        this.control().removeAt(i);
        this.filteredDeleteActivity.push(value.id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  deleteMatrix(value, i, j) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
const control = (this.activityForm.get('Activities') as FormArray).at(i).get('Stakeholdermatrix') as FormArray;

        control.removeAt(j);
        this.filterDeleteMatrix.push(value.id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  deleteRaci(value, i, j) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = (this.activityForm.controls.Activity.get('Stakeholdermatrix')  as FormArray).at(i).get('Racies') as FormArray;
        control.removeAt(j);
        this.filteredDeleteRaci.push(value.id);
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  totalactions(id) {
    return this.actionpersons.filter(a => a.PLStageActivityId === id).length
  }

  // This method is used to create Task for already existing sta
  createTask(data) {
    this.activityForm.patchValue(data);
    this.addActivity(data);
  }

  // This method is used to edit stage
  editSavedData(data) {
    this.newActivity = true;
    const myData: FormGroup = this.fb.group(
      {
        PipelineLicenseStageName: [data.PipelineLicenseStageName, Validators.required],
        PipelineLicenseCategoryId: data.PipelineLicenseCategoryId,
        EstimatedDuration: [data.EstimatedDuration, Validators.required],
        TemplateId: data.TemplateId,
        newStage: data.newStage,
        StageNo: data.StageNo,
        id:  data.id,
        Activity: this.fb.group({
        id: [data.Activity.id],
        isNew: [data.Activity.isNew],
        ActivityNo: data.Activity.ActivityNo,
        CreatedById: [data.Activity.CreatedById],
        ModifiedById: [data.Activity.ModifiedById],
        SiteId: [data.Activity.SiteId],
        TemplateId:[data.Activity.TemplateId],
        SubscriberId: [data.Activity.SubscriberId],
        PLStageId: [data.Activity.PLStageId, Validators.required],
        Name: [data.Activity.Name, Validators.required],
        EstimatedDuration: [data.Activity.EstimatedDuration, Validators.required],
        Stakeholdermatrix : this.fb.array([]),
        Actionpersons: this.fb.array([])
      })
  }
    )

    if(data.Activity.Actionpersons) {
      data.Activity.Actionpersons.map((action, i) => {
        const actioncontrol = myData.controls.Activity.get('Actionpersons') as FormArray;
        actioncontrol.push(this.fb.group({
          id: action.id,
          isNew: action.isNew,
          CreatedById: action.CreatedById,
          ModifiedById: action.ModifiedById,
          SiteId: action.SiteId,
          SubscriberId: action.SubscriberId ,
          StaffId: [action.StaffId, Validators.required],
          PLStageActivityId: action.PLStageActivityId
        }));

      })
    }

  if(data.Activity.Stakeholdermatrix) {
    data.Activity.Stakeholdermatrix.map((mm, i) => {
      const firstcontrol = myData.controls.Activity.get('Stakeholdermatrix') as FormArray;
      firstcontrol.push(this.fb.group({
        id: mm.id,
        isNew: mm.isNew,
        CreatedById: mm.CreatedById,
        ModifiedById: mm.ModifiedById,
        SiteId: mm.SiteId,
        TemplateId: mm.TemplateId,
        SubscriberId:mm.SubscriberId ,
        EstimatedDuration: [mm.EstimatedDuration, [Validators.required]],
        PLStakeholderId: [mm.PLStakeholderId, Validators.required],
        PLStageActivityId:[mm.PLStageActivityId, Validators.required],
        Racies: this.fb.array([])
      }));



      if(mm.Racies) {
      mm.Racies.map(rr => {
        const control = (myData.controls.Activity.get('Stakeholdermatrix')  as FormArray).controls[i].get('Racies') as FormArray;
        control.push(this.fb.group(rr));
    })
      }
    })
  }

    this.activityForm = myData;
}
  // This method is used to set Exiting activity in saved stage
  setActivity(activity) {
    const findStage = this.savedstages.find(a => a.id === activity.PLStageId);
    if(findStage) {
      const stage = {
        PipelineLicenseStageName: findStage.PipelineLicenseStageName,
        PipelineLicenseCategoryId: findStage.PipelineLicenseCategoryId,
        EstimatedDuration: findStage.EstimatedDuration,
        TemplateId: activity.TemplateId,
        newStage: findStage.newStage,
        StageNo: findStage.StageNo,
        id: findStage.id,
        Activity: activity
      }

      this.editSavedData(stage);
    }
  }

  control() {
  return this.activityForm.controls.Activities as FormArray;
  }

  newStage(data) {
    if(this.activityForm.valid) {
      this.addActivity(data);
    }
    this.createForm();
    this.addCategoryId();
    // this.addPlStageId(data);
  }


  onSubmitActivity(data) {
    const pullData = [];
    if(this.filteredDeleteActivity.length > 0) {
    this.deleteActivityEvent.emit(this.filteredDeleteActivity);
    }

    if(this.filterDeleteMatrix.length > 0) {
    this.deleteMatrixEvent.emit(this.filterDeleteMatrix);
    }

    if(this.filteredDeleteRaci.length > 0) {
      this.deleteRaciEvent.emit(this.filteredDeleteRaci);
    }

    // //check if the form data is not saved and is valid then save to the savedstages array;
    if(this.f['EstimatedDuration'].valid && this.f['PipelineLicenseStageName'].valid) {
        this.addActivity(data);
    }

    // check if the savedstages is valid then push to pull data;
    if(this.savedstages.length) {
        for(const stage of this.savedstages) {
          const filteredactivity = this.savedactivities.filter(la => la.PLStageId === stage.id);
          const newstage = {
            PipelineLicenseStageName: stage.PipelineLicenseStageName,
            PipelineLicenseCategoryId: stage.PipelineLicenseCategoryId,
            EstimatedDuration: stage.EstimatedDuration,
            TemplateId: stage.TemplateId,
            newStage: stage.newStage,
            StageNo: stage.StageNo,
            id: stage.id,
            Activities: filteredactivity
          };
          pullData.push(newstage);
        }
    }

    if(pullData.length > 0) {
        // if the data is valid then emit the data to activity component
        this.submiteventemitter.emit(pullData);
    }
  }
}
